<template>
  <div class="menu-under-bar">
    <ul>
      <li
        v-for="(item, index) in propsMenuLists"
        :key="index"
        @click.stop="setPositionMenuUnderBar(item.name)"
        :id="item.name"
      >
        {{ item.title }}
      </li>
    </ul>
    <div ref="underBar" class="under-bar"></div>
  </div>
</template>

<script>
import * as types from '../../store/mutation-types'
import { mapGetters } from 'vuex'
import { of } from 'rxjs'
import { map, delay } from 'rxjs/operators'

export default {
  name: 'menu-under-bar-modal',
  props: {
    propsMenuLists: {
      default: () => ({
        0: {
          title: 'Default1',
          name: 'main',
          sort: 0
        },
        1: {
          title: 'Default2',
          name: 'main1',
          sort: 0
        },
        2: {
          title: 'Default3',
          name: 'main2',
          sort: 0
        },
        3: {
          title: 'Default4',
          name: 'main3',
          sort: 0
        },
        4: {
          title: 'Default5',
          name: 'main4',
          sort: 0
        }
      }),
      type: Object
    }
  },
  data() {
    return {
      currentMenu: ''
    }
  },
  mounted() {
    new Promise(resolve => {
      let check = setInterval(() => {
        if (this.modalRequestComponentName !== '') {
          resolve(true)
          clearInterval(check)
        }
      }, 500)
    }).then(() => {
      console.log(
        'this.modalRequestComponentName:',
        this.modalRequestComponentName
      )
      this.setPositionMenuUnderBar(this.modalRequestComponentName)
    })
  },
  methods: {
    setPositionMenuUnderBar(component) {
      this.$nextTick().then(() => {
        const target = this.$el.querySelector('#' + component)
        const underBar = this.$refs.underBar
        underBar.className = 'animated under-bar fadeOut'
        if (target) {
          underBar.style.width = 0
          const target$ = of(target).pipe(
            delay(500),
            map(e => ({ left: e.offsetLeft, width: e.offsetWidth }))
          )
          target$.subscribe(e => {
            underBar.className = 'animated under-bar fadeInUp'
            underBar.style.left = e.left + 'px'
            underBar.style.width = e.width + 'px'
          })

          this.$store
            .dispatch(types.SET_MODAL_REQUEST_COMPONENT, {
              component: component,
              propData: {}
            })
            .finally(() => {
              console.log('모달창 안에서 라우팅 완료')
            })
        } else {
          this.setPositionMenuUnderBar(component)
        }
      })
    }
  },
  computed: {
    ...mapGetters(['modalRequestComponentName'])
  }
}
</script>

<style lang="scss" scoped>
.menu-under-bar {
  height: 26px;
  /*border: green 1px dotted;*/
  position: relative;
  ul {
    position: absolute;
    margin: 0;
    padding: 0;
    list-style: none;
    z-index: 10;
    li {
      display: inline-block;
      margin: 0 10px 0 0;
      padding: 0 5px;
      cursor: pointer;
      height: 26px;
      font-family: Poppins;
      font-size: 16px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 1px;
      text-align: left;
      color: #000000;
    }
  }

  .under-bar {
    display: block;
    width: 0;
    height: 14px;
    background-color: #fed6cf;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 0;
  }
}
</style>
